import React from 'react';
import PropTypes from 'prop-types';
import { withI18n } from '@lingui/react';
import cx from 'classnames';

import FieldHoc from './FieldHoc';

const SwitchField = React.forwardRef(
    ({ input, meta, inputType, placeholder, className, i18n, ...rest }, ref) => {
        // console.warn(ref);
        // console.warn(input);

        return (
            <label className="form-switch !inline-block">
                <input
                    ref={rest.forwardRef}
                    {...input}
                    type="checkbox"
                />
                <i className="form-icon !top-3 lg:!top-1" />{' '}
                <span className="">{i18n._(placeholder)}</span>
            </label>
        );
    }
);

SwitchField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string
};

const SwitchFieldWithI18n = withI18n()(SwitchField);

export default FieldHoc(SwitchFieldWithI18n);

{/* <input
    ref={rest.forwardRef}
    {...input}
    type={inputType}
    placeholder={i18n._(placeholder) + (rest.mandatory ? '*' : '')}
    className={cx(className, {
        'is-error': meta.error && meta.touched
    })} 
/>*/}